import { render } from "./Dummy.vue?vue&type=template&id=6df40818&scoped=true"
const script = {}

import "./Dummy.vue?vue&type=style&index=0&id=6df40818&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df40818"]])

export default __exports__